var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('h3',[_vm._v(" Valor Total: "),_c('strong',[_vm._v(_vm._s(_vm._f("currency")(_vm.price)))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }